import React from 'react'
import AdmIssueReturnReport from '../../components/AdminTabs/AdminIssueReturnReport/AdmIssueReturnReport'

const IssueReturnReport = () => {
  return (
    <div>
        <AdmIssueReturnReport/>
    </div>
  )
}

export default IssueReturnReport